import { Box, FieldSet, Legend, Text } from '@zillow/constellation-10';

import type { AvailabilityDate } from '../../../../../types/TourAvailabilityCards';
import TourAvailabilityCards from '../../../../TourAvailabilityCards/TourAvailabilityCards';
import type { TimeZoneIds } from '../../../../../constants/TourCalendar';
import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';

type AvailabilityBodyProps = {
  availabilityDates: Array<AvailabilityDate>;
  timeZone: TimeZoneIds;
  tourDuration?: TourDuration;
  onAvailabilityDatesChange: (availabilityDates: Array<AvailabilityDate>) => void;
};

const AvailabilityBody = ({
  availabilityDates,
  timeZone,
  tourDuration,
  onAvailabilityDatesChange,
}: AvailabilityBodyProps) => {
  return (
    <Box data-testid="AvailabilityBody" css={{ display: 'flex', flexDirection: 'column', gap: 'loose' }}>
      <Text>
        Add a few dates and times up to three weeks from today. Then you can start booking tours as soon as your
        listing’s live. We recommend you add more after your listing is published.
      </Text>
      <FieldSet legend={<Legend size="lg">Tour availability</Legend>} required>
        <TourAvailabilityCards
          availabilityDates={availabilityDates}
          onAvailabilityDatesChange={onAvailabilityDatesChange}
          timeZone={timeZone}
          tourDuration={tourDuration}
        />
      </FieldSet>
    </Box>
  );
};

export default AvailabilityBody;
